<div class="info-popup" [class.is-active]="activeClass">
    <div class="info-popup__inner">
        <div class="info-popup__content">
            {{message}}
        </div>

        <button class="info-popup__btn" (click)="closePopup()"></button>
    </div>
</div>
